import { motion, useReducedMotion } from "framer-motion";
import { Check, X } from "lucide-react";
import { generationSteps } from "../lib/generation-steps";
import type { GenerationJob } from "../types";

// Aceternity Multi Step Loader, controlled by server state instead of a timer.
export function MultiStepLoader({ job }: { job: GenerationJob }) {
  const reduced = useReducedMotion();
  return <div className="multi-step-loader">
    <div className="multi-step-heading"><span>Подготовка выпуска</span><span role="status" aria-live="polite">{
      job.status === "queued" ? "В очереди" : job.status === "completed" ? "Готово" : job.status === "failed" ? "Ошибка" : job.status === "cancelled" ? "Отменено" : `${Math.min(5, Math.max(1, job.phase + 1))} / 5`
    }</span></div>
    <ol>{generationSteps(job).map((step, index) => <motion.li key={step.title} className={`step-${step.state}`}
      aria-current={step.state === "active" ? "step" : undefined} initial={false}
      animate={{ x: !reduced && step.state === "active" ? 6 : 0 }} transition={{ duration: reduced ? 0 : .3 }}>
      {step.state === "active" && <motion.span className="step-highlight" layoutId="generation-active-step" transition={{ duration: reduced ? 0 : .3 }} />}
      <span className="step-number" aria-hidden="true">{step.state === "complete" ? <Check size={15} /> : step.state === "failed" ? <X size={15} /> : String(index + 1).padStart(2, "0")}</span>
      <span className="step-copy"><b>{step.title}</b><small>{step.detail}</small></span>
      <span className="sr-only">{step.state === "complete" ? "Завершено" : step.state === "active" ? "В работе" : step.state === "failed" ? "Ошибка" : step.state === "cancelled" ? "Остановлено" : "Ожидает"}</span>
    </motion.li>)}</ol>
  </div>;
}
